import { Injectable, Inject } from '@angular/core';
import { EnvironmentProvider } from './browser-providers';
import { Environment } from '../../environments/enviroment.model';
import { Http, RequestOptionsArgs, Headers } from '@angular/http';
import { Role } from '../security/role/role.model';

@Injectable()
export class RoleService {

  private tokenId = 'jwtToken';
  protected backendUrl: string;
  constructor(
    protected http: Http,
    @Inject(EnvironmentProvider) env: Environment,
  ) {
    this.backendUrl = env.endpoints.apiBack;
  }

  checkNameNotTaken(name: string) {
    return this.http.get(this.buildUrl(Role.path + 'existsByName/' + name),
    this.buildRequestOptions(undefined)).map(res => res.json());
  }

  private buildUrl(path: string) {
    return this.backendUrl + encodeURI(path);
  }

  private buildRequestOptions(options: RequestOptionsArgs = {}) {
    options.headers = options.headers || new Headers();
    options.headers.append('Content-Type', 'application/ld+json');
    const token = this.token;
    if (token) {
      options.headers.append('Authorization', 'Bearer ' + token);
    }
    return options;
  }

  get token() {
    return localStorage.getItem(this.tokenId);
  }
}



// WEBPACK FOOTER //
// ./src/app/core/role.service.ts